<template>
    <div class="feedback-container"
        :style="{
            'background':`linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
        }" >
        <!-- <navbar></navbar> -->
        <div class="feedback" v-if="!showInfo">
            <header-feedback :index="index" :steps="3"></header-feedback>
            <div class="container">
                <router-view :index="index"></router-view>
            </div>
            <!-- <footer-default></footer-default> -->
        </div>
       
        <info-default 
            v-if="showInfo"
            :smallTitle="smallTitle"
            :title="title"
            :descInfo="desc"
            actionName="goFeedback"
            :textButton="$t('containers.FeedbackContainer.textButton')"
            :noStyle="true"><Icon></Icon></info-default>
    </div>
</template>
<script>
import {Bus} from '../event-bus.js'
import InfoDefault from '../components/shared/default/InfoDefault.vue'
import HeaderFeedback from '../components/feedback/HeaderFeedback.vue'
import FooterDefault from '../components/shared/default/FooterDefault.vue'
import Navbar from '../components/shared/header/Navbar'
import Icon from '../components/shared/customIcons/feedback.vue'
export default {
    components:{
        InfoDefault,
        HeaderFeedback,
        FooterDefault,
        Navbar,
        Icon
    },
    data(){
        return{
            smallTitle : this.$t("containers.FeedbackContainer.smallTitle"),
            title : this.$t("containers.FeedbackContainer.title"),
            desc : this.$t("containers.FeedbackContainer.desc"),
            index : 0, 
            showInfo : true,
            colors: {}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        Bus.$on('goFeedback', this.goFeedback)
        Bus.$on('nextStep', this.nextStep)
        let routeName = this.$route.name
        routeName == 'Feedback' ? this.showInfo = true : this.showInfo = false
        
        if(routeName != 'Feedback' && this.index == 0){
            this.$router.push('/feedback')
            this.showInfo = true
        }
    },
    destroyed(){
        Bus.$off('goFeedback')
        Bus.$off('nextStep')
    },
    methods: {
        async goFeedback(){
            await this.$router.push('/feedback-experience')
            this.showInfo = false
        },
        nextStep(){
            this.index = this.index + 1
        }
    }
}
</script>
<style lang="scss" scoped>
    .feedback-container{
        background-size:cover !important;
        width: 100%;
        height: 100%;
        .feedback{
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .container{
            height: 90vh;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            padding: 0;
            overflow: auto; 
        }
    }
</style>

